import React from 'react';
import StoryCard from 'components/shared/StoryCard';
import { useEffect, useState } from 'react';
import axios from 'axios';




const Dashboard = () => {

    const [stories, setStories] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStories = async () => {
            try {
                const config = {
                    headers: {
                        'Accept': 'application/json',
                    }
                };
            
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/cuentos`, config);
                console.log('Stories dashboard:', response.data);
                setStories(response.data);
            } catch (error) {
                console.error('Error fetching stories:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchStories();
    }, []);

    return (
        <div className='min-h-screen bg-gradient-to-br from-japanese-paper via-pearl-50 to-sage-50'>
            {/* Hero Section */}
            <div className='pt-[120px] pb-16 px-6'>
                <div className='max-w-4xl mx-auto text-center'>
                    <h1 className='text-5xl md:text-7xl font-bold text-japanese-ink font-japanese mb-6 leading-tight'>
                        📚 Cuentos Japoneses
                    </h1>
                    <p className='text-lg md:text-xl text-charcoal-600 max-w-3xl mx-auto leading-relaxed'>
                        Los cuentos tradicionales japoneses, conocidos como <ruby className="text-japanese-ink font-japanese text-xl"><rb>昔話</rb><rt className="text-sm">むかしばなし</rt></ruby> <strong>(mukashibanashi)</strong> , han sido transmitidos de generación en generación durante siglos. 
                        Estas historias no solo entretienen, sino que enseñan valores importantes como la honestidad, el respeto y la perseverancia. 
                        <br /><br />
                        Personajes como Momotarō, Urashima Tarō y la princesa Kaguya forman parte del alma cultural de Japón. 
                        A través de estas narraciones, podrás conocer las tradiciones, creencias y la sabiduría popular japonesa mientras practicas el idioma de manera natural y divertida.
                    </p>
                    <div className='mt-8 flex flex-wrap justify-center gap-4'>
                        <div className='bg-primary-100 text-primary-700 px-4 py-2 rounded-full text-sm font-semibold'>
                            🌸 {stories.length} Cuentos disponibles
                        </div>
                        <div className='bg-sage-100 text-sage-700 px-4 py-2 rounded-full text-sm font-semibold'>
                            🎌 Cultura tradicional
                        </div>
                        <div className='bg-japanese-paper text-charcoal-700 px-4 py-2 rounded-full text-sm font-semibold border border-charcoal-200'>
                            📖 Aprende mientras lees
                        </div>
                    </div>
                </div>
            </div>

            {/* Stories Grid */}
            <div className='max-w-6xl mx-auto px-6 pb-20'>
                {loading ? (
                    <div className='flex justify-center items-center py-20'>
                        <div className='text-center'>
                            <div className='animate-spin rounded-full h-16 w-16 border-4 border-primary-200 border-t-primary-600 mx-auto mb-4'></div>
                            <p className='text-charcoal-600 font-semibold'>Cargando cuentos...</p>
                        </div>
                    </div>
                ) : (
                    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
                        {stories.map((cuento) => (
                            <div key={cuento.id} className='transform hover:scale-[1.02] transition-transform duration-300'>
                                <StoryCard data={cuento} />
                            </div>
                        ))}
                    </div>
                )}
                
                {!loading && stories.length === 0 && (
                    <div className='text-center py-20'>
                        <div className='text-6xl mb-4'>📖</div>
                        <h3 className='text-2xl font-bold text-charcoal-600 mb-2'>No hay cuentos disponibles</h3>
                        <p className='text-charcoal-500'>Próximamente agregaremos más historias fascinantes.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Dashboard;